import { useState } from "react";
import { useMsal } from "@azure/msal-react";
import { Button } from "src/components/ui/button";
import { readSignOutReason, takeSignInRequest } from "src/auth/tokenRejection";
import { BrandLogo } from "src/brand/BrandLogo";
import { getBrand } from "src/brand/brand";

interface SignInScreenProps {}

const SignInScreen = () => {
	const { instance } = useMsal();
	// Set when the API ended this tab's session because the account signed in
	// somewhere else (the concurrent session cap).
	const [signOutReason] = useState(readSignOutReason);

	// The reason is cleared only when the user signs in again, never on
	// mount, so a remount can't lose it before the user has read it. The
	// request is a fresh sign-in when the API ended this tab's last session.
	const signIn = () => {
		void instance.loginRedirect(takeSignInRequest());
	};

	return (
		<div className="flex min-h-screen items-center justify-center bg-subtle px-4">
			<div className="w-full max-w-[400px] flex flex-col items-center rounded-xl bg-card border border-border p-6 shadow-lg">
				<BrandLogo className="h-8 w-auto mb-8" />

				{signOutReason === "replaced" && (
					<p
						role="status"
						className="text-caption text-foreground text-center mb-6"
					>
						You were signed out because your account signed in on another device
						or browser.
					</p>
				)}

				{getBrand().tagline && (
					<p className="text-caption text-muted-foreground mb-8">
						Sign in to access {getBrand().tagline}
					</p>
				)}

				<Button className="w-full" onClick={signIn}>
					Sign in
				</Button>
			</div>
		</div>
	);
};

export { SignInScreen, type SignInScreenProps };
